import { SpaceModel } from "./interfaces/Space";
import ls from "localstorage-slim";

const SPACE_LIST = "spaceList";
const LAST_UPDATE = "last_update";
const TTL = 3600;
type SpaceListObj = {
  spaceList: SpaceModel[];
};

function setLastUpdated(lastUpdate: number | undefined) {
  if (!lastUpdate) return;
  ls.set(LAST_UPDATE, lastUpdate);
}

function getLastUpdated(): number {
  return Number(ls.get(LAST_UPDATE));
}

function setSpaceList(spaceList: SpaceModel[]) {
  ls.set(SPACE_LIST, { spaceList }, { ttl: TTL });
}

function getSpaceList(): SpaceModel[] | undefined {
  const spaceListLs = ls.get(SPACE_LIST);
  if (spaceListLs) {
    return (spaceListLs as SpaceListObj).spaceList;
  }
}

export { setSpaceList, getSpaceList, setLastUpdated, getLastUpdated };
